import React, { ReactNode, useEffect, useMemo } from 'react';
import { PersistQueryParamsConfig } from '@warehouse/shared/util';
import {
	TitleEditorStoreProviderInternal,
	TitleEditorStore,
	titleEditorStoreSelector,
	useTitleEditorStore,
} from './title-editor.store';

function SeedTitleUuid({ titleUuid }: { titleUuid: string }) {
	const { setTitleUuid } = useTitleEditorStore(titleEditorStoreSelector.actions);

	useEffect(() => {
		setTitleUuid(titleUuid);
	}, [setTitleUuid, titleUuid]);

	return null;
}

export function TitleEditorStoreProvider({ children, titleUuid }: { children: ReactNode; titleUuid?: string }) {
	const config = useMemo(
		(): PersistQueryParamsConfig<TitleEditorStore> => ({
			editMode: {
				type: 'boolean',
				keyName: 'edit',
				defaultValue: false,
			},
		}),
		[],
	);

	return (
		<TitleEditorStoreProviderInternal config={config}>
			{titleUuid !== undefined && <SeedTitleUuid titleUuid={titleUuid} />}
			{children}
		</TitleEditorStoreProviderInternal>
	);
}
